import { getDomain } from './config';
import i18n from './i18n';

const domain = getDomain();

export const AXIOS_TIMEOUT = 30000;
export const BASENAME = '/design-tools';
export const COOKIES = {
	POLICY_CONSENT: 'wd_policyConsent'
};
export const SUPPORT_EMAIL = {
	label: 'design.tools@onsemi.com',
	url: 'design.tools@onsemi.com?subject=Design Tools (WebDesigner+)'
};

export const COMMUNITY_FORUM = {
	label: i18n.t('utils.constants.forumLabel'),
	url: 'https://community.onsemi.com/s/topicanddiscussion'
};

export const URL = {
	ONSEMI: `https://www.${domain}`,
	ONSEMI_MY_ON_PROFILE: `https://www.${domain}/PowerSolutions/myon/home.do`,
	WEBDESIGNER_PLUS: `https://www.${domain}/design-tools`,
	WEBDESIGNER_PLUS_SHORT: `${domain}/design-tools`,
	PRODUCT_PAGE_PREFIX: `https://www.${domain}/PowerSolutions/product.do?id=`,
	SALES_SUPPORT: `https://www.${domain}/support/sales`
};

export const DEFAULT_SELECTED_CHARTS = [
	'EfficiencyVsIout',
	'Efficiency_ByVinStep',
	'DutyCycleVsIout',
	'IcTemperatureVsIout',
	'IcJunctionTemperatureVsVin',
	'PdissTotalVsIout'
];
